import { render } from "./doctor_slider.vue?vue&type=template&id=15c4d680"
import script from "./doctor_slider.vue?vue&type=script&lang=js"
export * from "./doctor_slider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__